import styled from "styled-components";
import {
  animations,
  colors,
  devices,
} from "../../utils/styled/_variables.styled";

export const KoerberButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 48px;
  padding: 16px 24px;
  background: ${colors.blue};
  color: ${colors.white};
  border-radius: 100px;
  border: none;
  white-space: nowrap;
  ${(props) =>
    props.hasCustomTransition ? "" : `transition: ${animations.buttonLink};`};

  cursor: pointer;

  &:hover {
    svg {
      transform: ${(props) =>
        props.animatedVertically ? animations.vertical : animations.cta};
    }
  }

  &.disabled {
    background: ${colors.gray2};
    color: ${colors.gray4};
    pointer-events: none;

    &.secondary {
      border: ${colors.gray4} 1px solid;
    }

    svg {
      path {
        fill: ${colors.gray4};
      }
    }
  }

  @media ${devices.mobileAndTablet} {
    ${(props) => (props.fullWidthOnMobileAndTablet ? "width: 100%" : "")};
  }

  &.partner {
    background: ${colors.yellow};
    color: ${colors.black};

    svg {
      path {
        fill: ${colors.black};
      }
    }

    &:hover {
      background: ${colors.lightOrange};
      color: ${colors.black};

      svg {
        path {
          fill: ${colors.black};
        }
      }
    }
    &:active {
      background: ${colors.yellow};
    }
  }

  &.secondary,
  &.tertiary {
    background: transparent;
    color: ${colors.blue};

    &.disabled {
      color: ${colors.gray4};

      svg {
        path {
          fill: ${colors.gray4};
        }
      }
    }

    svg {
      path {
        fill: ${colors.blue};
      }
    }
  }

  &.secondary {
    border: ${colors.blue} 2px solid;
    position: relative;

    &:after {
      content: "";
      width: calc(100% + 2px);
      transform: translate(-1px, -1px);
      height: calc(100% + 2px);
      display: flex;
      position: absolute;
      border: 2px solid white;
      border-radius: 100px;
      top: 0;
      left: 0;
    }
    &:hover {
      border: 2px solid ${colors.blueHover};

      &:after {
        display: none;
      }
    }
  }

  &.blue {
    background: #324155;
    color: #ffffff;

    svg {
      path {
        fill: #ffffff;
      }
    }

    &:hover, &:active {
      background: #E7E7E7;
      color: #324155;

      svg {
        path {
          fill: #324155;
        }
      }
    }    
  }

  &.green {
    background: #D0FF25;
    color: #324155;

    svg {
      path {
        fill: #324155;
      }
    }

    &:hover, &:active {
      background: #324155;
      color: #ffffff;

      svg {
        path {
          fill: #ffffff;
        }
      }
    }    
  }

  &.greenlight {
    background: #D0FF25;
    color: #324155;

    svg {
      path {
        fill: #324155;
      }
    }

    &:hover, &:active {
      background: #E7E7E7;    
      color: #324155;

      svg {
        path {
          fill: #324155;
        }
      }        
    }    
  }

  &.white {
    background: #ffffff;
    color: #000000;

    svg {
      path {
        fill: #000000;
      }
    }

    &:hover {
      background: #324155;
      color: #ffffff;

      svg {
        path {
          fill: #ffffff;
        }
      }
    }
    &:active {
      background: #324155;
    }
  }

  &.inverted {
    background: ${colors.white};
    color: ${colors.blue};

    &.disabled {
      color: ${colors.gray4};

      svg {
        path {
          fill: ${colors.gray4};
        }
      }
    }

    &.secondary,
    &.tertiary {
      background-color: transparent;
      color: ${colors.white};

      &.disabled {
        color: ${colors.white};
        opacity: 0.64;
      }

      &:hover {
        background: transparent;
      }

      svg {
        path {
          fill: ${colors.white};
        }
      }
    }

    &.secondary {
      border: ${colors.white} 1px solid;

      &:hover {
        background: ${colors.white};
      }
    }

    &.tertiary {
      &:hover {
        background: transparent;
        color: ${colors.white};
        opacity: 0.64;

        svg {
          path {
            fill: ${colors.white};
          }
        }
      }

      &:active {
        color: ${colors.bluePressed};
        opacity: 1;

        svg {
          path {
            fill: ${colors.bluePressed};
          }
        }
      }
    }

    &:hover {
      background: ${colors.white};
      color: ${colors.blueHover};

      svg {
        path {
          fill: ${colors.blueHover};
        }
      }
    }

    &:active {
      color: ${colors.bluePressed};
      opacity: 1;

      svg {
        path {
          fill: ${colors.bluePressed};
        }
      }
    }

    svg {
      path {
        fill: ${colors.blue};
      }
    }
  }

  &:hover {
    background-color: ${(props) =>
      !props.secondary && !props.tertiary ? colors.blueHover : "transparent"};
    color: ${(props) =>
      !props.secondary && !props.tertiary ? colors.white : colors.blueHover};

    svg {
      path {
        fill: ${(props) =>
          !props.secondary && !props.tertiary
            ? colors.white
            : colors.blueHover};
      }
    }

    border-color: ${(props) => (props.secondary ? colors.blueHover : "none")};
    border: ${(props) => (props.secondary ? "2px solid" : "none")};
  }

  &:visited {
    color: inherit;
  }

  &:active {
    background-color: ${(props) =>
      !props.secondary && !props.tertiary ? colors.bluePressed : "transparent"};
    color: ${(props) =>
      !props.secondary && !props.tertiary ? colors.white : colors.bluePressed};

    svg {
      path {
        fill: ${(props) =>
          !props.secondary && !props.tertiary
            ? colors.white
            : colors.bluePressed};
      }
    }

    border-color: ${(props) =>
      props.secondary ? colors.bluePressed : "initial"};
  }

  svg {
    display: ${(props) => (props.noIcon ? "none" : "flex")};
    margin-left: 12px;

    path {
      transition: ${animations.buttonLink};
      fill: ${colors.white};
    }
  }

  &.is_floating {
    position: fixed;
    bottom: 30px;
    right: 20px;
    z-index: 2147483646;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.3);
    opacity: 1;
  }

  &.is_floating.hidden {
    display: none;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  &.is_floating.visible {
    display: inline-flex;
    opacity: 1;
    transition: opacity 0.5s ease;
  }

  &.is_floatingAboveChat {
    position: fixed;
    bottom: 33%;
    right: 38px;
    z-index: 2147483646;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.3);
    opacity: 1;
    cursor: pointer;
  }

  &.is_floatingAboveChat.hidden {
    display: none;
    opacity: 0;
    transition: opacity 0.5s ease;
    
  }

  &.is_floatingAboveChat.visible {
    display: inline-flex;
    opacity: 1;
    transition: opacity 0.5s ease; 
  }
`;
